/**
 * The module-level S1 cache slot (U79), kept free of imports so the app's
 * logout handler can clear it without pulling in the API client.
 */
let cache = { token: null, promise: null };

/** @returns {{ token: string|null, promise: Promise<Object>|null }} */
export const readLinksMetaCache = () => cache;

/** @param {{ token: string|null, promise: Promise<Object>|null }} next */
export const writeLinksMetaCache = (next) => {
  cache = next;
};

/** Forget the cached S1 response (logout, 403, IP/EXPORT_FORBIDDEN, LABEL_TEMPLATE_UNKNOWN). */
export function clearLinksMetaCache() {
  cache = { token: null, promise: null };
}
